import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { companyActions } from '../../../redux/actions/company-action';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import {
  Grid,
  Row,
  Col,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { savePagination, getSavedPagination } from '../../../helper/helperFunctions';
const queryString = require('query-string');

class CompanyListPage extends React.Component {
	constructor(props){
		super(props);
        const { savedPage, savedPageSize } = getSavedPagination("company");
        const parsed = queryString.parse(window.location.search);
        this.state = {
            sorted   :'',
            filtered :'',
            savedPage: parsed.restore_page ? savedPage : 0,
            savedPageSize: parsed.restore_page ? savedPageSize : 10,
        };
        this.companyPaginationData  = this.companyPaginationData.bind(this);
        this.filterSearchHandle     = this.filterSearchHandle.bind(this);
        this.deleteCompany = this.deleteCompany.bind(this);
        this.deleteConfirmCompany = this.deleteConfirmCompany.bind(this);
	}
  componentDidMount() {
    const { savedPage, savedPageSize } = this.state;
		this.props.getCompanyCall(savedPage + 1, [], '', savedPageSize);
	}
  deleteConfirmCompany(id){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Company</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the company?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteCompany(id)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  deleteCompany(id){
    this.props.deleteCompanyCall(id);
  }
  filterSearchHandle(e){
      this.setState({
          'filtered': e.target.value
      });
  }
	companyPaginationData(page, filter, sort, pageSize){
		this.props.getCompanyCall(page, filter, sort, pageSize);
	}
  onFetchData = (state) => {
    // SAVE to localStorage
    savePagination("company", state.page, state.pageSize);
    this.setState({
      savedPage: state.page,
      savedPageSize: state.pageSize
    })
    var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
    state.pageData(state.page+1, state.filtered, sort, state.pageSize);
  };
	render(){
        const { data,pages,loading  } = this.props;
        const { filtered } = this.state;
		    const columns = [
            {
                Header:"Company Listing",
                columns: [
                    {
                        Header: "Company",
                        accessor: "name",
                        className: "action-center"
                    },
                    {
                        Header: "Address 1",
                        accessor: "address1",
                        className: "action-center"
                    },
                    {
                        Header: "City",
                        accessor: "city",
                        className: "action-center"
                    },
                    {
                        Header: "State",
                        accessor: "state",
                        className: "action-center"
                    },
                    {
                        Header: "Zip",
                        accessor: "zip",
                        className: "action-center"
                    },
                    {
                        Header:"Actions",
                        accessor: "id",
                        Cell: ({value}) => (
                          <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Company Users</Tooltip>}>
                            <Link to={'/Admin/Company/'+value+'/users?Companies'} className="action-button-size"><i className="fa fa-users " /></Link>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Company</Tooltip>}>
                            <Link to={'/Admin/Edit-Company/'+value+'?Companies'} className="action-button-size"><i className="fa fa-pencil" /></Link>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Company</Tooltip>}>
                            <button onClick={()=>this.deleteConfirmCompany(value)} className="action-button-size"><i className="fa fa-trash " /></button>
                          </OverlayTrigger>
                          </div>
                          ),
                        className: "action-center",
                        sortable:false
                    }
                ]
            }
        ];
		return(
            <div className="content">
                <Grid fluid>
                  <Row>
                    <Col md={12}>
                      <Card
                        title="Companies List"
                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                                <Row>
                                    <Col md={2} sm={6} xs={12}>
                                        <div>
                                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Add Company</Tooltip>}>
                                            <Link to="/Admin/Add-Company"   className="outOfTableButton btn btn-info btn-block"><i className="fa fa-plus" />Company</Link>
                                          </OverlayTrigger>
                                        </div>
                                    </Col>
                                    <Col md={4} sm={6} xs={12} mdOffset={6}>
                                      <div>
                                        <FormInputs
                                          ncols={["col-md-12"]}
                                          onChange={this.filterSearchHandle}
                                          proprieties={[
                                            {
                                              type: "text",
                                              bsClass: "form-control",
                                              placeholder: "Seach Companies",
                                              onChange:this.filterSearchHandle,
                                              name:"filter"
                                            }

                                          ]}
                                        />
                                      </div>
                                    </Col>
                                </Row>
                            </Grid>
                            <ReactTable
                                
                                data={data}
                                pages={pages} 
                                loading = {loading}
                                columns={columns}
                                filtered={filtered}
                                page={this.state.savedPage}
                                pageSize={this.state.savedPageSize}
                                className="striped hover"
                                pageData = {this.companyPaginationData}
                                manual
                          			onFetchData={this.onFetchData}
                                // onFetchData={(state, instance) => {
                                //     var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
                                //     state.pageData(state.page+1, state.filtered, sort, state.pageSize);
                                // }}
                            />
                          </div>
                        }
                      />
                    </Col>
                  </Row>
                </Grid>
            </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getCompanyCall  : (page, filter, sort, pageSize) => { dispatch(companyActions.getCompaniesPagination(page, filter, sort, pageSize)) },
    deleteCompanyCall  : (id) => { dispatch(companyActions.deleteCompany(id)) }
  });
};

function mapStateToProps(state) {
    
    const { data,pages,loading } = state.companyReducer;
    return {
        data,pages,loading
    };
}

const CompanyList = connect(mapStateToProps, mapDispatchToProps)(CompanyListPage);

export default CompanyList;


// WEBPACK FOOTER //
// ./src/components/Admin/Company/CompanyList.jsx